export const JSON_PATH_SEPARATOR = '.';
export const JSON_PATH_TYPE_SEPARATOR = '::';
export const JSON_PATH_TYPE_DEFAULT_CAST_TYPE = '::text';
export const ATTRIBUTE_PATH_SEPARATOR = '/';
